import React, { ButtonHTMLAttributes } from 'react';
import styled from 'styled-components';

import { BgColorInterface, TextColorInterface } from './config/CommonInterfaces';
import { rgba } from '../helpers/rgba';

const ButtonContainer = styled.button<{ bgColor: string, textColor: string, dis: boolean, flat: boolean }>`
  background-color: ${({ flat, dis, bgColor, theme: { colors } }) => flat ? 'transparent' : dis ? rgba(colors.general[`${bgColor}`.toUpperCase()], 0.4) : colors.general[`${bgColor}`.toUpperCase()]};
  color: ${({ flat, textColor, theme: { colors } }) => colors.text[`${textColor}`.toUpperCase()]};
  border-radius: ${({ theme: { units } }) => units.sizes.BORDER_RADIUS};
  padding: ${({ theme: { units } }) => units.spacing.MICRO};
  padding-left: ${({ flat, theme: { units } }) => flat ? '0px' : units.spacing.MICRO};
  padding-right: ${({ flat, theme: { units } }) => flat ? '0px' : units.spacing.MICRO};
  apparence: none;
  -webkit-appearance: none;
  border-color: transparent;
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: 600;
  cursor: pointer;
  display: inline-block;
  margin: 0 0 0 auto;
`;

const ButtonWrapper = styled.div`
  display: inline-block;
  margin-top: ${({ theme: { units } }) => units.spacing.NONE};
  border-radius: ${({ theme: { units } }) => units.sizes.BORDER_RADIUS};
`;

interface LinkButtonProps extends BgColorInterface, TextColorInterface, ButtonHTMLAttributes<HTMLElement> {
  children: string,
  disabled: true | false,
  flat: true | false,
}

function LinkButton({
  children, bgColor, textColor,
  disabled, flat,
  ...rest
}: LinkButtonProps) {
  return (
    <ButtonWrapper>
      <ButtonContainer
        className="button-component"
        bgColor={bgColor}
        textColor={textColor}
        dis={disabled}
        disabled={disabled}
        flat={flat}
        {...rest}
      >
        { children }
      </ButtonContainer>
    </ButtonWrapper>
  );
}

export default LinkButton;

LinkButton.defaultProps = {
  bgColor: 'primary',
  textColor: 'white',
  disabled: false,
  flat: false,
};
